export class CandidateProfilePageController {
    /*@ngInject*/
    constructor() {
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.candidateId = this.$stateParams.candidateId;
    }
}
// import * as TEMPLATE from './candidate-profile-page.html';
import * as TEMPLATE from 'raw-loader!./candidate-profile-page.html';
export const CandidateProfilePageComponent = {
    selector: 'candidateProfilePage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidate-profile-page.html',
        template: TEMPLATE.default,
        controller: CandidateProfilePageController
    }
};
//# sourceMappingURL=candidate-profile-page.component.js.map